document.addEventListener("DOMContentLoaded", function() {
    const toggleButton = document.getElementById('toggleButton');
    let isExpanded = false;

    if (toggleButton) {
        function toggleTags() {
            const tags = document.querySelectorAll('.tags div:not(#toggleButton):nth-child(n+5)');
            tags.forEach(tag => {
                tag.style.display = isExpanded ? 'none' : 'block';
            });

            toggleButton.textContent = isExpanded ? 'Voir +' : 'Voir -';
            isExpanded = !isExpanded;
        }

        toggleButton.addEventListener('click', toggleTags)
    }


    function checkWindowSize() {
        // Vérifie si la largeur de la fenêtre est inférieure à 768px
        if (window.innerWidth < 768) {
            // Assurez-vous que le bouton est dans l'état correct si les tags sont déjà dépliés
            if (isExpanded) {
                const tags = document.querySelectorAll('.tags div:not(#toggleButton):nth-child(n+5)');
                tags.forEach(tag => {
                    tag.style.display = 'block';
                });
            }
        }
    }

    // Vérifiez la taille de la fenêtre au chargement
    checkWindowSize();

    // Ajoutez un gestionnaire d'événements pour les changements de taille de la fenêtre
    window.addEventListener('resize', checkWindowSize);
});
